var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" "+_vm._s(_vm.getDisplay)+" "),_c('md-tooltip',{attrs:{"md-delay":"50"}},[_vm._v(_vm._s(_vm.tagId))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }